import AxiosConfig from '@/config/axios-config'
import StringUtils from '@/core/utils/string-utils'

export default {

  listarUF () {
    return AxiosConfig.ibgeAPI().get('/localidades/estados').then(response => {
      if (response && response.data) {
        return response.data.sort((uf1, uf2) => uf1.nome.localeCompare(uf2.nome))
      }
      return null
    })
  },

  listarPaises () {
    return AxiosConfig.restcountriesAPI().get('/all').then(response => {
      if (response && response.data) {
        return response.data.map(pais => StringUtils.capitalize(pais.translations.br)).sort((s1, s2) => s1.localeCompare(s2))
      }
      return null
    })
  }

}
